import Card from "./Card";
import { useMovieSwap } from "../hooks/useMovieSwap";
import { DataTable } from "./DataTable/DataTable";
import { swapFilmColumns } from "./DataTable/columns";
import CollapsibleSection from "./CollapsibleSection";
import Spinner from "./Spinner";
import type { SwapFilm } from "../../shared/types";
import { Notification } from "./ui/Notification";

interface MovieSwapProps {
  user1: string;
  user2: string;
  user1Label: string;
  user2Label: string;
}

interface SwapListProps {
  films: SwapFilm[];
  rater: string;
  heading: string;
}

const SwapList = ({ films, rater, heading }: SwapListProps) => (
  <CollapsibleSection title={`${heading} (${films.length})`}>
    {films.length === 0 ? (
      <p className="text-letterboxd-text-muted">Nothing to recommend.</p>
    ) : (
      <div className="overflow-x-auto">
        <DataTable
          data={films}
          columns={swapFilmColumns}
          enableSort
          initialSort={{ key: "user_rating", direction: "desc" }}
          headerContext={{ rater }}
        />
      </div>
    )}
  </CollapsibleSection>
);

const MovieSwap = ({
  user1,
  user2,
  user1Label,
  user2Label,
}: MovieSwapProps) => {
  const { data, loading, error } = useMovieSwap(user1, user2);

  return (
    <Card>
      <h3 className="subheading">Movie Swap</h3>
      <p className="text-letterboxd-text-secondary mb-4">
        Films each user has rated that the other hasn't seen.
      </p>

      {loading && <Spinner />}

      {error && (
        <Notification status={{ type: "error", message: error }} />
      )}

      {data && !loading && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <SwapList
            films={data.recsForUserA}
            rater={user2Label}
            heading={`Movies that ${user2Label} saw ${user1Label} hasn't seen`}
          />
          <SwapList
            films={data.recsForUserB}
            rater={user1Label}
            heading={`Movies that ${user1Label} saw ${user2Label} hasn't seen`}
          />
        </div>
      )}
    </Card>
  );
};

export default MovieSwap;
